document.addEventListener("DOMContentLoaded", function() {
  const wrappers = document.querySelectorAll(".card-hover");

  wrappers.forEach(wrapper => {
    const cardBg = wrapper.querySelector(".card-bg");
    const cardBgHover = wrapper.querySelector(".card-bg-hover");

    // Mostrar a segunda imagem no hover
    wrapper.addEventListener("mouseenter", () => {
     
      cardBgHover.style.display = "block";
    });

    // Mostrar a primeira imagem ao sair do hover
    wrapper.addEventListener("mouseleave", () => {
      cardBg.style.display = "block";
  
    });
  });
});
